import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  // {
  //   path: '/index',
  //   name: 'home',
  //   // component: HomeView
  //   component: HomeView
  // },
  {
    path: '/',
    name: 'demoIndex',
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  },{
    path: '/main',
    name: 'main',
    component: () => import(/* webpackChunkName: "about" */ '../views/mainPage.vue')
  },
  {
    path: '/index',
    name: 'demoIndex2',
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  },
  {
    path: '/index/:rid/:did',
    name: 'indexId',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  },
  {
    path: '/index/:countrycode/:rid/:did',
    name: 'indexCid',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  },
  {
    path: '/index/:countrycode',
    name: 'indexCountry',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  },
  {
    path: '/landshop/:countrycode/:shopid',
    name: 'landshop',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/landShopPage.vue')
  },
  {
    path: '/hallshop/:countrycode/:shopid',
    name: 'hallshop',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/hallShopPage.vue')
  },
  {
    path: '/hallshop/:shopid',
    name: 'hallshop',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/hallShopPage.vue')
  },

  {
    path: '/:islandID/index',
    name: 'demoIndex2Island',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  },
  {
    path: '/:islandID/index/:rid/:did',
    name: 'indexIdIsland',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  },
  {
    path: '/:islandID/index/:countrycode/:rid/:did',
    name: 'indexCidIsland',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  },
  {
    path: '/:islandID/index/:countrycode',
    name: 'indexCountryIsland',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  },



  {
    path: '/islandArea',
    name: 'islandArea',
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage20.vue')
  },
  {
    path: '/islandArea/:rid/:did',
    name: 'islandArea2',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage20.vue')
  },
  {
    path: '/islandArea/:countrycode/:rid/:did',
    name: 'islandArea2',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage20.vue')
  },
  {
    path: '/islandArea/:countrycode',
    name: 'islandArea4',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage20.vue')
  },


  {
    path: '/:islandID/islandArea',
    name: 'islandArea5',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage20.vue')
  },
  {
    path: '/:islandID/islandArea/:rid/:did',
    name: 'islandArea6',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage20.vue')
  },
  {
    path: '/:islandID/islandArea/:countrycode/:rid/:did',
    name: 'islandArea7',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage20.vue')
  },
  {
    path: '/:islandID/islandArea/:countrycode',
    name: 'islandArea8',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage20.vue')
  },


  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/phone',
    name: 'phone',
    meta: {
      keepAlive: false
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/phoneDemo.vue')
  },
  {
    path: '/card',
    name: 'card',
    meta: {
      keepAlive: false
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/cardDemo.vue')
  },
  {
    path: '/card/:cardId',
    name: 'cardFromID',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/cardDemo.vue')
  },
  {
    path: '/adv',
    name: 'adv',
    meta: {
      keepAlive: false
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/testAdvView.vue')
  },
  {
    path: '/test/:hallId',
    name: 'test',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../components/shopopee/print/format/exhibitor/exhibitorPrinter.vue')
  },
  // {
  //   path: '/demo17',
  //   name: 'demo17',
  //   meta: {
  //     keepAlive: false
  //   },
  //   props: true,
  //   component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  // },
  // {
  //   path: '/demo17/:rid/:did',
  //   name: 'demo17Id',
  //   meta: {
  //     keepAlive: false
  //   },
  //   props: true,
  //   component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  // },
  // {
  //   path: '/demo17/:countrycode/:rid/:did',
  //   name: 'demo17Cid',
  //   meta: {
  //     keepAlive: false
  //   },
  //   props: true,
  //   component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  // },
  // {
  //   path: '/demo17/:countrycode',
  //   name: 'demo17Country',
  //   meta: {
  //     keepAlive: false
  //   },
  //   props: true,
  //   component: () => import(/* webpackChunkName: "about" */ '../views/demoPage17.vue')
  // },
  // {
  //   path: '/demo18',
  //   name: 'demo18',
  //   meta: {
  //     keepAlive: false
  //   },
  //   props: true,
  //   component: () => import(/* webpackChunkName: "about" */ '../views/demoPage18.vue')
  // },
  {
    path: '/demo19',
    name: 'demo19',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage19.vue')
  },
  {
    path: '/hall',
    name: 'hall',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage18.vue')
  },

  {
    path: '/hallSearch/:hid',
    name: 'hallSearch',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/hallSearchPage.vue')
  },

  {
    path: '/hall/:hid',
    name: 'hallHid',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage18.vue')
  },
  {
    path: '/hall/:fid/:did',
    name: 'hallId',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage18.vue')
  },
  {
    path: '/hall/:hid/:fid/:did',
    name: 'hallCid',
    meta: {
      keepAlive: false
    },
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage18.vue')
  },
  {
    path: '/myCard',
    name: 'myCard',
    component: () => import(/* webpackChunkName: "about" */ '../views/myCardView.vue')
  },
  {
    path: '/shopController',
    name: 'shopController',
    component: () => import(/* webpackChunkName: "about" */ '../views/shopControllerView.vue')
  },
  {
    path: '/materialController',
    name: 'materialController',
    component: () => import(/* webpackChunkName: "about" */ '../components/shopopee/material/materialEditor.vue')
  },
  {
    path: '/banner01',
    name: 'banner01',
    component: () => import(/* webpackChunkName: "about" */ '../views/ShopopeeBanner.vue')
  },
  {
    path: '/myCompany/:mfrom',
    name: 'myCompany',
    component: () => import(/* webpackChunkName: "about" */ '../views/myCompany.vue')
  },
  {
    path: '/myBill',
    name: 'myBill',
    component: () => import(/* webpackChunkName: "about" */ '../views/myBill.vue')
  },
  {
    path: '/chatroom/:rid',
    name: 'chatroom',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/chatRoomView.vue')
  },
  {
    path: '/loading/:page',
    name: 'loadingPage',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/loadingView.vue')
  },
  {
    path: '/hallLook/:hid',
    name: 'hallLookViewWithId',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/hallOverlookView.vue')
  },
  {
    path: '/hallLook',
    name: 'hallLookView',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/hallOverlookView.vue')
  },
  {
    path: '/hallLookManager/:tag',
    name: 'hallLookManagerView',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/hallOverlookView.vue')
  },
  {
    path: '/hallLookManager/:tag/:hid',
    name: 'hallLookManagerViewWithId',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/hallOverlookView.vue')
  },
  {
    path: '/cardEditor',
    name: 'cardEditor',
    component: () => import(/* webpackChunkName: "about" */ '../views/cardEditorView.vue')
  },
  {
    path: '/qmain',
    name: 'qmain',
    component: () => import(/* webpackChunkName: "about" */ '../views/quotationMain.vue')
  },
  {
    path: '/qmain/:companycode',
    name: 'qmainCode',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/quotationMain.vue')
  },
  {
    path: '/myQuotation',
    name: 'myQuotation',
    component: () => import(/* webpackChunkName: "about" */ '../views/myQuotation.vue')
  },
  {
    path: '/pe',
    name: 'pe',
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage19.vue')
  },
  {
    path: '/Personal/:rid',
    name: 'Personal',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/demoPage21.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/loginView.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
  },
  {
    path: '/agentProdut',
    name: 'agentProdut',
    component: () => import(/* webpackChunkName: "about" */ '../views/agentProdutDemo.vue')
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import(/* webpackChunkName: "about" */ '../views/chatView.vue')
  },
  {
    path: '/savecard',
    name: 'savecard',
    component: () => import(/* webpackChunkName: "about" */ '../views/saveCardView.vue')
  },
  {
    path: '/mallManager',
    name: 'mallManager',
    component: () => import(/* webpackChunkName: "about" */ '../views/mallManagerView.vue')
  },
  {
    path: '/islandManager',
    name: 'islandManager',
    component: () => import(/* webpackChunkName: "about" */ '../views/islandManagerView.vue')
  },
  {
    path: '/inviteMall/:hid',
    name: 'inviteMall',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../views/inviteMall.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,

  //--------------------------------------------------
  //以下內容為生產環境使用，開發環境時請注釋
  // history: createWebHistory("/3d/"),
  // base: "/3d/",
  //--------------------------------------------------
  routes
})

export default router
